/* global globals */
import React, { Component } from 'react';
import PropTypes from 'prop-types';

import get from 'lodash/get';
import isEqual from 'lodash/isEqual';
import forOwn from 'lodash/forOwn';

import PaymentsInfo from '../../components/payments';

class PaymentsInfoContainer extends Component {
  state = {
    payments: null,
  };

  fetchPayments = this.fetchPayments.bind(this);

  componentDidMount() {
    this.fetchPayments();
  }

  // eslint-disable-next-line camelcase
  UNSAFE_componentWillReceiveProps(nextProps) {
    const { query } = this.props;
    if (isEqual(nextProps.query, query)) {
      this.fetchPayments();
    }
  }

  fetchPayments() {
    const { query } = this.props;
    if (!query) {
      return;
    }

    let url = `${get(globals, 'apiWebroot', '/')}payments/get?'`;
    const params = query;
    forOwn(params, (value, key) => {
      url += `${key}=${value}`;
    });
    fetch(url, { mode: 'no-cors', credentials: 'same-origin' })
      .then((resp) => resp.json())
      .then((data) => {
        const payments = [];
        if (data.constructor !== Array || data.length < 0) {
          this.setState({ payments: [] });
          return;
        }
        data.forEach((item) => {
          if (get(item, '_id', null)) {
            payments.push(item);
          }
        });
        this.setState({ payments });
      })
      .catch(() => {
        // console.log('fetch failed: ', error);
      });
  }

  render() {
    const { payments } = this.state;

    if (payments) {
      return (
        <div>
          <PaymentsInfo payments={payments} />
        </div>
      );
    }

    return (<div />);
  }
}

PaymentsInfoContainer.propTypes = {
  query: PropTypes.shape({}),
};

PaymentsInfoContainer.defaultProps = {
  query: PropTypes.shape({}),
};

export default PaymentsInfoContainer;
